import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Payment from './pages/Payment'
import Success from './pages/Success'
import Failed from './pages/Failed'
import Cancelled from './pages/Cancelled'
import NotFound from './pages/NotFound'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/p/:shortCode" element={<Payment />} />
        <Route path="/p/:shortCode/success" element={<Success />} />
        <Route path="/p/:shortCode/failed" element={<Failed />} />
        <Route path="/p/:shortCode/cancelled" element={<Cancelled />} />
        <Route path="/p/cancelled" element={<Cancelled />} />
        <Route path="/p/failed" element={<Failed />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  )
}
